import { t } from '@/plugins/i18n'
interface ROW_TYPE {
  type:number,
  orderType: number,
  customerOperateType: number,
  abnormalDetailType?: number
}
export const changeT = (rowItem : ROW_TYPE) => {
  const { type, orderType, customerOperateType } = rowItem
  const defaultObj: any = {
    取消商品: t('取消商品采购'), // 囤货
    换个链接: t('请在我指定的新链接下采购'),
    同款链接: t('请在THE CKB为我推荐的此链接下采购'),
    等待原链接: t('可以等待，请继续在原链接采购'),
    类似款链接: t('请在THE CKB为我推荐的此链接下采购'),
    下单原链接: t('我接受起订量，请继续在原链接采购'),
    '下单原链接（多出数量保留库存）': t('我接受起订量，请继续在原链接采购'),
    良品入库: t('问题不大，我能接受，请当成良品入库'),
    不良品: t('此问题我不能接受，请依然当成不良品处理')
  }
  defaultObj['取消商品'] = orderType === 2 ? t('取消商品采购') : t('取消商品采购+商品发送')
  // 商品确认
  if (type === 1) {
    defaultObj['换个链接'] = t('请在我指定的新链接购买')
  }
  // 全网断货
  if (type === 2) {
    defaultObj['换个链接'] = t('我有可能有货的采购链接，请在这个链接再尝试购买')
  }
  // 预售商品
  if (type === 4) {
    defaultObj['换个链接'] = t('我等不及，请在我指定的新链接下采购')
    defaultObj['同款链接'] = t('我等不及，请在THE CKB为我推荐的此链接下采购')
  }
  // 不满足最小起订量
  if (type === 5) {
    defaultObj['换个链接'] = t('我不接受起订量，请在我指定的新链接下采购')
    defaultObj['同款链接'] = t('我不接受起订量，请在THE CKB为我推荐的此链接下采购')
    defaultObj['下单原链接'] = t('我接受起订量，请继续在原链接采购（多采部分商品无异常上架后将作为库存在THE CKB仓库代为保管，并可匹配其他直发订单发出）')
  }
  // 更换同款链接
  if (type === 6) {
    defaultObj['换个链接'] = t('THE CKB推荐的链接价格等不合适，请在我指定的新链接下采购')
    defaultObj['同款链接'] = t('请在THE CKB为我推荐的此链接下采购')
    defaultObj['下单原链接'] = t('我还是要继续在原链接采购')
  }
  // 次品
  if (type === 7) {
    defaultObj['取消商品'] = orderType === 2 ? t('次品退货退款并取消商品采购') : t('次品退货退款并取消商品采购+商品发送')
    if (customerOperateType !== 0) {
      // 异常处理完查看详情type 8 会转为7
      defaultObj['换个链接'] = t('此问题我不能接受，请依然当成不良品处理，并在我指定的新链接购买')
      defaultObj['取消商品'] = orderType === 2 ? t('此问题我不能接受，请依然当成不良品处理，并取消商品采购') : t('此问题我不能接受，请依然当成不良品处理，并取消商品采购+商品发送')
    }
  }
  // 异常
  if (type === 8) {
    defaultObj['换个链接'] = t('此问题我不能接受，请依然当成不良品处理，并在我指定的新链接购买')
    defaultObj['取消商品'] = orderType === 2 ? t('此问题我不能接受，请依然当成不良品处理，并取消商品采购') : t('此问题我不能接受，请依然当成不良品处理，并取消商品采购+商品发送')
  }
  // 倒错货
  if (type === 10) {
    defaultObj['换个链接'] = t('THE CKB推荐的链接价格等不合适，请在我指定的新链接下采购')
    defaultObj['取消商品'] = orderType === 2 ? t('取消商品重拍') : t('取消商品重拍+商品发送')
  }
  // 少件
  if (type === 12) {
    defaultObj['取消商品'] = orderType === 2 ? t('取消商品重拍') : t('取消商品重拍+商品发送')
  }
  return defaultObj
}
export const handleResult = (item:ROW_TYPE) => {
  const defaultObj = changeT(item)
  const cT = (t: string) => {
    return defaultObj[t]
  }
  const { customerOperateType, type, abnormalDetailType } = item
  switch (customerOperateType) {
    case 1:
      return cT('更换颜色')
    case 2:
      return cT('更换尺码')
    case 3:
      return cT('更换款式')
    case 4:
      return cT('换个链接')
    case 5:
      return cT('取消商品')
    case 6:
      return cT('同款链接')
    case 7:
      return cT('类似款链接')
    case 8:
      if (type === 4) {
        return t('等待原链接')
      }
      if (type === 6) {
        return cT('下单原链接')
      }
      break
    case 10:
      if (type === 5 && abnormalDetailType === 6) {
        return cT('下单原链接')
      }
      break
    case 11:
      return cT('良品入库')
    case 12:
      return cT('不良品')
    case 13:
      return t('次品退货退款并付费重拍')
    case 14:
      return t('按原价采购')
    case 15:
      return cT('换个链接')
    case 16:
      return t('该商品取消采购和发货，订单下其余商品（若有）正常发货')
    case 17:
      return t('该商品取消采购和发货，订单下其余商品（若有）也取消发货，转为库存')
    case 18:
      return t('该商品取消采购和发货，订单下其余商品（若有）自定义发货或转为库存')
    case 19:
      return t('不能接受该不良，希望同商品换货（该换货无需重新冻结费用，如供应商无货，则系统会自动取消）')
  }
  if (type === 5 && abnormalDetailType === 4) {
    return cT('下单原链接')
  }
  return ''
}
